import { Injectable } from '@angular/core';
import { datadogRum, RumGlobal } from '@datadog/browser-rum';
import { AppConfigService } from './app-config.service';
import { AuthService } from 'src/app/auth/auth.service';
import { Profile } from '../models/profile';
import { InjectorModule } from '../modules/injector.module';
import { OidcSecurityService } from 'angular-auth-oidc-client';

@Injectable({
  providedIn: 'root'
})
export class DatadogRumService {
  public readonly rum: RumGlobal;
  constructor() {
    this.rum = datadogRum;
  }

  public initLineupApp({ config, tenant }: Pick<AppConfigService, 'config' | 'tenant'>): void {
    this.congiguration({ config, tenant });
    const authService = InjectorModule.injector.get(AuthService);
    authService.hasAuthenticated.subscribe(({ authenticated }) => {
      if (authenticated) {
        authService.getProfile().subscribe((profile: Profile) => {
          datadogRum.setUser({ id: profile.userId, name: profile.nickname });
        });
      } else {
        datadogRum.removeUser();
      }
    });
  }

  public initLineupPortal({ config, tenant }: Pick<AppConfigService, 'config' | 'tenant'>): void {
    this.congiguration({ config, tenant });
    const authService = InjectorModule.injector.get(OidcSecurityService);
    authService.userData$.subscribe((res) => {
      if (res && res.userData) {
        datadogRum.setUser({
          id: res.userData.sub,
          name: `${res.userData.given_name} ${res.userData.family_name}`
        });
      } else {
        datadogRum.removeUser();
      }
    });
  }

  private congiguration({ config, tenant }: Pick<AppConfigService, 'config' | 'tenant'>): void {
    const isAnEnvWhereWeDontWantToRunDataDog = ['dev', 'development'].includes(config.name);
    if (isAnEnvWhereWeDontWantToRunDataDog) {
      return;
    }
    datadogRum.init({
      applicationId: '8a07d5d4-d151-4cdd-ad3e-8473848120be',
      clientToken: 'pubab7d6de67febcf84b03b9d5436c3ff98',
      service: 'lineup-ui',
      env: config.production ? 'lineup-prod' : config.staging ? 'lineup-staging' : 'lineup-dev',
      site: 'datadoghq.com',
      // Specify a version number to identify the deployed version of your application in Datadog
      version: config.version,
      sessionSampleRate: 100,
      sessionReplaySampleRate: 100,
      trackUserInteractions: true,
      defaultPrivacyLevel: 'mask-user-input',
      allowedTracingUrls: [window?.location.origin]
    });
    datadogRum.startSessionReplayRecording();
    datadogRum.setRumGlobalContext({ tenant: { ...tenant } });
  }
}
